module.exports = "<div ng-if=\"$ctrl.error \">\n<h2>{{$ctrl.title | translate}}</h2>\n<p>{{$ctrl.description | translate}}</p>\n<pre ng-if=\"$ctrl.details\">{{$ctrl.details}}</pre>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/error/error.html
// module id = 562
// module chunks = 0